<template>
  <div v-if="show" class="d-flex justify-content-between align-items-center">
    <i
      class="far fa-file-circle-info ml-1 link"
      title="Support Details"
      @click="toggleModal"
    ></i>
    <sera-modal
      :open="modalOpen"
      modalTitle="Support Details"
      hideFooter
      @close="handleModalClose"
    >
      <div v-if="loading">
        <Spinner message="Loading Support Details..." />
      </div>
      <div v-else class="m-2 mt-4">
        <div>
          <sera-button-link
            label="Query Tool"
            :href="queryToolUrl"
            icon="up-right-from-square"
            openNewTab
          ></sera-button-link>
        </div>
        <div
          v-for="event in batchItemEvents"
          :key="event.id"
          class="support-detail-event mt-4"
        >
          <h3 class="page-header-2">
            Event #{{ event.id }}
            <span
              v-if="event.batch_id < batchId"
              style="color: var(--sera-color-accents-red-600)"
            >
              (Previous Batch #{{ event.batch_number }})
            </span>
          </h3>
          <h5>{{ event.message }}</h5>
          <h5>{{ event.created_at }}</h5>
          <div
            v-if="event.sync_errors.length > 0"
            class="event-errors ml-2 mt-2"
          >
            Errors:
            <div
              v-for="eventError in event.sync_errors"
              :key="eventError.id"
              class="event-error"
            >
              <pre>{{ eventError.message }}</pre>
              <pre>{{ eventError.backtrace.join("\n") }}</pre>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && batchItemEvents.length === 0">
        No QBO Events were logged for this batch item.
      </div>
    </sera-modal>
  </div>
</template>

<script>
import API from "serviceshift-ui/api-client";

import Spinner from "@/components/Spinner.vue";

export default {
  components: { Spinner },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    batchId: {
      type: Number,
      default: null
    },
    batchItemId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      modalOpen: false,
      loading: true,
      batchItemEvents: []
    };
  },
  computed: {
    queryToolUrl() {
      return `/accounting/qbo_support?batch_item_id=${this.batchItemId}`;
    }
  },
  methods: {
    async toggleModal() {
      this.modalOpen = !this.modalOpen;

      if (this.modalOpen) {
        this.loading = true;
        this.batchItemEvents = await this.fetchBatchItemEvents();
        this.loading = false;
      }
    },
    async fetchBatchItemEvents() {
      try {
        const res = await API.makeRequest(
          `/accounting/batches/${this.batchId}/items/${this.batchItemId}/events`,
          {
            method: "GET"
          }
        );
        return res.data;
      } catch (e) {
        this.modalOpen = false;
      }
    },
    handleModalClose() {
      this.modalOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.support-detail-event {
  .event-errors {
    .event-error {
      border: 1px solid var(--gray-border-color);
    }
  }
}
</style>
